import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

export const Community = {
  shape: PropTypes.shape({
    communityId: PropTypes.string,
    project: PropTypes.string,
    communityName: PropTypes.string,
    active: PropTypes.bool,
    customerNumber: PropTypes.string,
    invoiceLevel: PropTypes.string,
    supplierId: PropTypes.string,
    agreementId: PropTypes.string,
    salesContactName: PropTypes.string,
    salesContactEmail: PropTypes.string,
    customerContactName: PropTypes.string,
    customerContactEmail: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.string),
  }),
  defaultValue: Immutable({
    communityId: '',
    project: '',
    communityName: '',
    active: false,
    customerNumber: '',
    invoiceLevel: 'Workspace',
    supplierId: '',
    agreementId: '',
    salesContactName: '',
    salesContactEmail: '',
    customerContactName: '',
    customerContactEmail: '',
    features: [],
  }),
};
